var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinux(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M254.707.005c-12.354-.134-24.86 2.369-35.736 8.23-11.559 6.229-21.028 16.193-26.863 27.957-5.831 11.758-8.123 24.316-8.469 38.146-.659 26.278.593 53.84 2.575 78.817.526 7.605 1.471 12.056.505 19.861-3.251 16.597-17.775 27.769-25.516 42.347-8.54 16.082-12.139 34.265-18.585 51.295-5.899 15.585-14.18 30.197-19.77 45.895-7.816 21.951-10.152 46.071-4.989 68.792 3.936 17.321 12.159 33.562 23.241 47.454-1.604 2.89-3.158 5.811-4.814 8.671-5.135 8.871-11.409 17.281-14.333 27.105-1.462 4.912-2.038 10.151-1.094 15.188.944 5.037 3.493 9.856 7.5 13.051 2.623 2.091 5.787 3.438 9.055 4.194 3.269.756 6.647.94 10.001.868 12.745-.271 25.093-4.145 37.422-7.382a428.467 428.467 0 0 1 22.066-5.15c26.267-5.381 55.584-3.233 79.968.303a285.242 285.242 0 0 1 24.577 4.847c12.715 3.081 25.385 7.01 38.463 7.382 3.442.098 6.912-.053 10.274-.801 3.361-.749 6.622-2.115 9.314-4.262 4.014-3.201 6.564-8.027 7.507-13.074.943-5.047.361-10.301-1.118-15.219-2.956-9.835-9.288-18.226-14.539-27.051-2.072-3.482-3.999-7.054-6.056-10.543 15.802-17.745 28.521-38.267 35.877-60.808 8.029-24.604 9.504-51.095 6.123-76.754-3.381-25.659-11.517-50.535-22.231-74.094-13.439-29.538-24.737-40.211-32.925-66.15-8.85-28.035-1.542-61.209-8.119-86.637-2.347-8.647-6.089-16.902-10.903-24.459-5.641-8.855-12.796-16.791-21.298-22.951C288.253 5.247 271.458.187 254.707.005z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M206.262 148.01c-1.803 2.26-2.978 4.976-3.687 7.779-.709 2.803-.969 5.701-1.08 8.591-.221 5.779.132 11.668-1.398 17.246-1.635 5.962-5.301 11.128-8.889 16.163-6.213 8.72-12.493 17.666-15.558 27.925a49.613 49.613 0 0 0-1.807 19.243 203.472 203.472 0 0 0-17.964 32.369c-7.56 17.135-12.747 35.378-14.572 54.017-2.234 22.823.685 46.297 9.699 67.383 6.517 15.246 16.232 29.203 28.758 40.066a98.308 98.308 0 0 0 21.009 13.955c26.219 12.887 58.623 12.911 84.406-.828 13.475-7.18 24.849-17.68 35.816-28.304 6.604-6.398 13.174-12.948 18.212-20.64 9.699-14.809 13.077-32.808 15.176-50.386 3.671-30.736 3.789-63.201-9.689-91.067a100.453 100.453 0 0 0-18.236-26.095 143.012 143.012 0 0 0-11.534-38.852c-4.086-8.885-9.08-17.342-12.876-26.354-1.558-3.7-2.913-7.488-4.642-11.111-1.73-3.623-3.863-7.109-6.764-9.885-2.97-2.842-6.672-4.857-10.575-6.147-3.904-1.289-8.013-1.873-12.119-2.08-8.212-.413-16.44.661-24.656.335-6.54-.26-13.06-1.406-19.594-1.02-3.267.193-6.534.777-9.566 2.008-3.032 1.23-5.828 3.131-7.87 5.689",
    style: {},
    fill: "#fcfcfa",
    "data-original": "#fcfcfa",
    className: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 2997.778,
    cy: 8238.369,
    r: 47.209,
    gradientTransform: "matrix(-.8062 0 0 -.7634 2579.212 6531.207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2489
    },
    stopColor: "#000000;stop-opacity:0.2489"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.329 230.358c1.751 2.626-1.089 11.682 39.717 5.886 0 0-7.166.788-14.23 2.42-10.984 3.677-20.552 7.785-27.932 13.228-7.312 5.38-12.667 12.404-19.377 18.437 0 0 10.866-19.853 13.575-25.831 2.709-5.978-.454-5.705 1.689-14.501 2.142-8.796 7.388-17.247 7.388-17.247s-4.283 12.428-.83 17.608z",
    style: {
      opacity: 0.25,
      fill: "url(#a)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 458.462,
    cy: 8211.089,
    r: 47.209,
    gradientTransform: "matrix(1 0 0 -.7634 -166.988 6531.207)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2489
    },
    stopColor: "#000000;stop-opacity:0.2489"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M308.546 227.988c-8.316 5.793-13.189 5.107-23.279 6.241-10.09 1.133-37.397.723-37.397.723s3.953-.074 12.715 1.558c8.762 1.632 26.634 3.193 36.697 7.023 10.063 3.83 13.734 4.923 19.85 8.791 8.706 5.505 15.095 14.128 23.417 20.16 0 0 .403-8.004-2.957-13.982s-12.393-15.4-15.05-24.196-3.92-26.08-3.92-26.08-1.76 13.968-10.076 19.762z",
    style: {
      opacity: 0.42,
      fill: "url(#b)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 395.397,
    cy: 7009.631,
    r: 18.692,
    gradientTransform: "matrix(1 0 0 -1.0692 -166.988 7749.891)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0.2489
    },
    stopColor: "#000000;stop-opacity:0.2489"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M230.332 215.616a104.03 104.03 0 0 1-1.201 7.487c-.242 1.223-.508 2.447-.964 3.607-.455 1.16-1.11 2.261-2.036 3.096-.811.732-1.8 1.234-2.793 1.689a41.982 41.982 0 0 1-12.251 3.48c1.689.124 3.376.278 5.059.462 1.061.116 2.123.245 3.157.51 1.033.265 2.042.671 2.903 1.302.944.691 1.686 1.634 2.239 2.665 1.103 2.054 1.472 4.417 1.676 6.739.261 2.97.28 5.962.057 8.935.2-1.989.617-3.957 1.241-5.856 1.125-3.423 2.937-6.632 5.377-9.284a20.068 20.068 0 0 1 3.204-2.84c3.582-2.521 8.132-3.629 12.472-3.036a19.369 19.369 0 0 1-12.399-3.849c-1.795-1.354-3.359-3.038-4.446-5.006a13.969 13.969 0 0 1-1.295-10.101",
    style: {
      opacity: 0.2,
      fill: "url(#c)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.698 274.286a152.875 152.875 0 0 0-4.353 24.606c-1.098 11.741-.834 23.565-1.464 35.34-.535 9.992-1.708 20.089.027 29.944a51.44 51.44 0 0 0 4.403 13.572c.332-1.637.575-3.293.728-4.957.735-7.99-.61-16.006-1.065-24.017-.797-14.042 1.147-28.076 1.939-42.118.608-10.78.536-21.599-.215-32.37",
    style: {
      opacity: 0.11,
      enableBackground: "new"
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.908 194.872c-.203-2.474-3.738-2.845-5.313-1.612-1.331 1.042-2.58 4.604-1.431 5.994 1.866 2.258 7.023-.99 6.744-4.382z",
    style: {
      opacity: 0.25,
      enableBackground: "new"
    },
    fill: "#7d7d7d",
    "data-original": "#7d7d7d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.16 262.466c2.047-.317 14.68 10.423 12.951 14.413-1.728 3.99-4.972 1.584-7.292 1.612s-8.669 2.91-9.733 1.09 2.808-6.067 4.834-9.618c1.631-2.859-2.807-7.18-.76-7.497z",
    style: {
      opacity: 0.75,
      enableBackground: "new"
    },
    fill: "#7d7d7d",
    "data-original": "#7d7d7d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.025 22.253c-4.418 3.118-2.488 7.011-.588 10.918 1.9 3.907-4.179 15.171-4.243 15.657-.064.486 11.965-5.71 15.244-9.735 3.872-4.753 13.657 6.43 13.124 4.729.003-3.044-19.119-24.687-23.537-21.569z",
    style: {},
    fill: "#7d7d7d",
    "data-original": "#7d7d7d",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.538 153.263c-3.727 3.394 1.747 8.493 4.343 14.485 1.614 3.725 6.078 8.971 10.397 8.131 3.248-.632 5.264-5.307 4.957-8.602-.593-6.357-5.958-7.846-9.854-10.03-3.088-1.731-7.226-6.367-9.843-3.984z",
    style: {},
    fill: "#838384",
    "data-original": "#838384",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.235 178.666c2.935 8.51 8.842 15.774 15.832 21.447 2.324 1.887 4.795 3.627 7.525 4.855 2.73 1.228 5.742 1.929 8.725 1.676 2.921-.248 5.7-1.395 8.253-2.836 2.553-1.442 4.922-3.183 7.399-4.752 4.244-2.689 8.79-4.863 13.197-7.275 5.313-2.907 10.461-6.188 14.934-10.271 2.047-1.869 3.957-3.909 6.218-5.513s4.969-2.767 7.735-2.579c2.075.141 4.021 1.024 6.054 1.461 1.017.219 2.07.326 3.098.17 1.028-.157 2.033-.594 2.754-1.343.883-.918 1.269-2.24 1.223-3.513-.046-1.273-.49-2.504-1.084-3.632-1.187-2.255-2.99-4.197-3.792-6.615-.714-2.152-.57-4.479-.507-6.746.063-2.267.013-4.635-1.032-6.647-.796-1.533-2.13-2.749-3.657-3.557-1.526-.808-3.238-1.224-4.957-1.385-3.438-.323-6.884.345-10.332.54-4.577.26-9.172-.313-13.749-.038-5.707.343-11.301 2-17.018 2.01-6.525.012-13.044-2.123-19.489-1.103-2.766.438-5.403 1.444-8.059 2.331-2.656.887-5.399 1.667-8.199 1.626-3.178-.046-6.255-1.147-9.426-1.373-1.585-.113-3.21 0-4.698.557-1.488.557-2.834 1.592-3.565 3.003-.419.809-.626 1.718-.665 2.628-.039.91.087 1.822.306 2.706.44 1.768 1.248 3.417 1.913 5.113 2.401 6.125 2.918 12.837 5.063 19.055",
    style: {
      fillOpacity: 0.2588
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.051 154.408c5.702 3.523 10.818 7.849 15.114 12.782 3.987 4.578 7.378 9.77 12.58 13.159 3.675 2.394 8.092 3.743 12.571 4.153 5.259.481 10.582-.297 15.652-1.67 4.699-1.273 9.244-3.063 13.413-5.432 7.925-4.503 14.545-11.101 23.285-14.061 1.908-.646 3.894-1.108 5.733-1.905 1.839-.797 3.57-1.991 4.449-3.679.844-1.623.812-3.497 1.087-5.279.294-1.906.954-3.75 1.317-5.646.362-1.896.405-3.925-.485-5.667-.737-1.443-2.078-2.584-3.619-3.309-1.542-.725-3.277-1.055-5.006-1.133-3.458-.156-6.873.659-10.32.949-4.567.384-9.165-.157-13.749-.03-5.702.158-11.32 1.348-17.018 1.596-6.501.283-12.985-.663-19.489-.875-2.813-.092-5.645-.045-8.418.401-2.773.446-5.495 1.304-7.839 2.74-2.275 1.393-4.131 3.282-6.216 4.907-1.043.813-2.151 1.564-3.367 2.135-1.217.571-2.549.96-3.913 1.02-.702.031-1.41-.024-2.105.075-1.165.166-2.247.784-2.927 1.671s-.951 2.03-.73 3.098",
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M365.51 254.239c10.487 8.436 17.141 21.175 19.202 34.476 1.607 10.373.562 21.018-1.776 31.251s-5.95 20.124-9.534 29.99c-1.429 3.934-2.865 7.906-3.433 12.053-.568 4.147-.208 8.539 1.792 12.216 2.293 4.215 6.572 7.118 11.172 8.485 4.541 1.349 9.447 1.32 14.044.175 4.597-1.146 12.336-2.63 16.078-5.536 9.506-7.382 11.763-20.198 14.015-31.453 2.349-11.738 1.2-24.044-.864-35.901-2.815-16.169-7.552-31.973-13.581-47.238a164.544 164.544 0 0 0-16.876-31.92c-6.631-9.77-16.04-17.395-22.992-26.947-2.415-3.319-5.32-6.776-7.693-10.132-5.116-7.235-3.958-5.885-7.131-10.568-2.303-3.398-5.939-4.565-9.765-6.051-3.826-1.486-8.122-1.924-12.073-.812-5.208 1.466-9.462 5.569-11.725 10.483-2.263 4.914-2.659 10.553-1.779 15.891 1.136 6.886 4.285 13.275 7.836 19.284 4.01 6.786 8.655 13.318 14.712 18.362 6.319 5.265 13.962 8.737 20.371 13.892M167.946 201.821c-12.191 13.852-24.736 27.26-31.619 42.235-3.406 7.606-5.017 15.869-7.351 23.87-2.651 9.086-6.25 17.873-10.291 26.432-3.731 7.903-7.842 15.62-11.959 23.329-2.996 5.608-6.041 11.343-7.08 17.616-.821 4.957-.342 10.073.92 14.936 1.262 4.864 3.291 9.498 5.58 13.971 9.768 19.088 24.422 35.542 41.781 48.129a146.81 146.81 0 0 0 25.168 14.695c4.796 2.19 9.847 4.144 15.118 4.235 2.636.046 5.298-.389 7.712-1.449 2.413-1.06 4.568-2.764 6.002-4.976 1.763-2.72 2.361-6.098 2.007-9.32-.354-3.221-1.611-6.296-3.298-9.064-4.119-6.76-10.626-11.652-16.884-16.5-13.513-10.468-26.585-21.51-39.093-33.16-3.532-3.289-7.064-6.683-9.531-10.831-2.403-4.039-3.701-8.641-4.581-13.258-2.412-12.666-1.794-25.996 2.516-38.147 1.686-4.754 3.914-9.293 6.064-13.856 3.725-7.909 7.251-15.969 12.15-23.211 6.098-9.015 14.249-16.65 19.22-26.332 4.195-8.172 5.894-17.36 7.518-26.401 1.27-7.074 3.706-14.002 4.945-21.082-2.424 4.593-10.235 12.137-15.014 18.139z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M386.67 319.69c-3.44 12.59-8.42 24.62-12.76 36.9-1.47 4.14-2.86 8.34-3.86 12.63-.43-2.36-.41-4.83-.08-7.21.57-4.15 2-8.12 3.43-12.05 3.59-9.87 7.2-19.76 9.54-29.99 2.33-10.24 3.38-20.88 1.77-31.26-2.06-13.3-8.71-26.03-19.2-34.47-6.26-5.04-13.7-8.47-19.93-13.53 7.09 3.87 14.5 7.25 20.97 12.03 11.21 8.3 19.13 20.86 21.38 34.47 1.79 10.83 2.17 19.89-1.26 32.48z",
    style: {},
    fill: "#838384",
    "data-original": "#838384",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.06 294.56c-4.31 12.15-4.92 25.48-2.51 38.15.88 4.62 2.18 9.22 4.58 13.26 2.47 4.15 6 7.54 9.53 10.83.54.51 1.09 1.01 1.63 1.5-.24-.02-.48-.04-.71-.07-2.59-.33-5.04-1.5-7.09-3.12-2.05-1.63-3.72-3.7-5.07-5.94-1.67-2.75-2.9-5.78-4.82-8.36-2.3-3.09-5.55-5.45-9.2-6.66 2.7-.96 5.03-2.92 6.43-5.42 1.68-2.99 2-6.55 1.88-9.97-.11-3.42-.62-6.84-.44-10.26.35-6.66 3.25-12.87 5.73-19.05 3.35-8.31 6.05-16.95 10.65-24.63a56.64 56.64 0 0 1 10.26-12.61 5.97 5.97 0 0 1 1.95-2.44c.61-.46 1.3-.79 2.04-.99-2.31 2.84-4.58 5.7-6.62 8.72-4.9 7.24-8.43 15.3-12.15 23.21-2.15 4.56-4.38 9.1-6.07 13.85z",
    style: {
      opacity: 0.95,
      enableBackground: "new"
    },
    fill: "#7d7d7d",
    "data-original": "#7d7d7d",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 565.02,
    x2: 571.391,
    y1: 7054.873,
    y2: 7007.329,
    gradientTransform: "matrix(1.0269 0 0 -1 -210.943 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000",
      stopOpacity: 0
    },
    stopColor: "#000000;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M436.096 431.214a28.253 28.253 0 0 1-3.628 7.602c-3.505 5.192-8.592 9.099-13.675 12.703-8.67 6.146-17.703 11.785-25.775 18.77-5.408 4.68-10.338 9.926-14.907 15.451-3.908 4.725-7.582 9.685-12.037 13.887-4.495 4.24-9.788 7.664-15.489 9.53-6.934 2.269-14.261 2.16-20.941.447-4.681-1.2-9.245-3.287-12.145-7.061-2.911-3.789-3.854-8.88-4.191-13.877-.596-8.839.46-17.872 1.422-26.845.799-7.455 1.537-14.917 1.838-22.357.548-13.533-.348-26.949-2.18-40.112-.307-2.205-.641-4.426-.454-6.697.186-2.271.948-4.633 2.542-6.386 1.473-1.619 3.527-2.578 5.576-3.049 2.049-.471 4.123-.499 6.182-.554 4.85-.129 9.728-.414 14.504.01 3.014.268 5.969.818 8.979 1.108 5.022.483 10.232.229 15.269-1.247 5.423-1.589 10.595-4.57 16.105-5.39 2.261-.336 4.529-.297 6.727.01 2.243.314 4.475.934 6.199 2.303 1.31 1.04 2.269 2.469 3.019 3.993 1.118 2.269 1.804 4.775 2.197 7.344.348 2.276.471 4.619 1.058 6.821.965 3.621 3.152 6.698 5.783 9.203 2.631 2.505 5.708 4.485 8.779 6.436 3.06 1.943 6.138 3.872 9.406 5.474 1.534.752 3.111 1.432 4.577 2.298 1.466.866 2.833 1.932 3.807 3.336 1.32 1.902 1.85 4.398 1.453 6.849",
    style: {
      opacity: 0.2,
      fill: "url(#d)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 604.967,
    x2: 687.839,
    y1: 6971.232,
    y2: 7105.595,
    gradientTransform: "matrix(1 0 0 -1 -266.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#422600"
    },
    stopColor: "#422600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#BE7900"
    },
    stopColor: "#be7900"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M465.626 445.833c-4.522 5.368-10.803 8.911-17.057 12.099-10.666 5.437-21.719 10.206-31.747 16.747-6.718 4.382-12.919 9.525-18.718 15.068-4.959 4.74-9.662 9.802-15.223 13.819-5.611 4.052-12.098 6.988-18.942 8.015-8.325 1.249-16.927-.367-24.645-3.73-5.408-2.357-10.609-5.727-13.724-10.736-3.127-5.028-3.84-11.182-3.848-17.104-.014-10.473 1.927-20.837 3.755-31.15 1.518-8.569 2.964-17.157 3.895-25.81 1.695-15.738 1.683-31.631.551-47.42-.189-2.644-.409-5.314-.014-7.935.395-2.621 1.473-5.234 3.483-6.963 1.856-1.597 4.345-2.303 6.79-2.438s4.885.253 7.307.607c5.709.834 11.464 1.491 17.044 2.958 3.521.926 6.951 2.17 10.466 3.121 5.864 1.586 12.007 2.346 18.041 1.641 6.496-.76 12.805-3.2 19.344-3.042 2.683.065 5.345.572 7.905 1.379 2.612.823 5.186 2.002 7.106 3.956 1.459 1.484 2.475 3.353 3.238 5.289 1.137 2.884 1.749 5.958 2.011 9.047.232 2.737.196 5.506.714 8.203.853 4.437 3.184 8.485 6.081 11.952 2.897 3.467 6.359 6.412 9.818 9.32 3.445 2.897 6.912 5.782 10.629 8.322 1.744 1.192 3.544 2.309 5.2 3.62 1.656 1.312 3.179 2.838 4.215 4.68 1.405 2.498 1.833 5.529.927 8.405-.906 2.876-2.553 5.647-4.602 8.08z",
    style: {
      fill: "url(#e)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.112 432.235a26.41 26.41 0 0 1-4.432 7.342c-4.141 4.85-9.874 8.022-15.577 10.877-9.743 4.878-19.825 9.165-28.992 15.056-6.125 3.936-11.79 8.558-17.093 13.546-4.531 4.262-8.833 8.818-13.902 12.423-5.138 3.655-11.061 6.285-17.299 7.205-7.599 1.121-15.443-.333-22.506-3.353-4.924-2.106-9.682-5.119-12.534-9.652-2.837-4.51-3.501-10.048-3.514-15.377-.023-9.418 1.755-18.736 3.429-28.004 1.391-7.702 2.715-15.422 3.557-23.203 1.531-14.147 1.462-28.434.504-42.631-.16-2.379-.345-4.781.02-7.137s1.341-4.701 3.147-6.257c1.694-1.46 3.969-2.099 6.202-2.216s4.459.244 6.672.57c5.21.767 10.466 1.343 15.565 2.66 3.215.83 6.349 1.95 9.557 2.806 5.359 1.429 10.965 2.111 16.475 1.475 5.931-.685 11.697-2.881 17.666-2.734 2.448.06 4.878.518 7.219 1.239 2.382.734 4.738 1.783 6.489 3.556 1.32 1.336 2.233 3.022 2.957 4.755 1.078 2.58 1.78 5.338 1.837 8.134.06 2.919-.578 5.851-.183 8.744.321 2.349 1.316 4.564 2.586 6.565 1.27 2.001 2.816 3.811 4.348 5.62 2.96 3.497 5.928 7.061 9.64 9.746 4.226 3.057 9.241 4.846 13.607 7.699 1.301.851 2.561 1.813 3.478 3.069 1.548 2.115 1.964 5.011 1.077 7.477",
    style: {},
    fill: "#e18900",
    "data-original": "#e18900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.503 429.225a32.058 32.058 0 0 1-4.553 7.415c-4.242 5.156-9.97 8.706-16.003 10.986-9.932 3.753-20.774 4.257-30.524 8.53-5.942 2.604-11.289 6.528-16.703 10.234-4.377 2.996-8.85 5.881-13.656 7.978-5.428 2.369-11.2 3.697-16.992 4.627-3.685.592-7.412 1.028-11.133.822-3.721-.206-7.455-1.078-10.739-2.975-2.49-1.439-4.73-3.511-6.059-6.198-1.477-2.986-1.733-6.491-1.699-9.874.09-9.018 2.02-17.938 1.962-26.956-.05-7.85-1.606-15.6-2.053-23.435-.86-15.068 2.373-30.4-.473-45.181-.456-2.366-1.068-4.73-1.038-7.146.016-1.208.195-2.423.621-3.541.427-1.117 1.109-2.135 2.018-2.841.766-.595 1.675-.956 2.607-1.119.932-.163 1.886-.131 2.82.015 1.868.29 3.648 1.024 5.467 1.566 5.204 1.549 10.702 1.517 15.991 2.686 3.32.734 6.534 1.936 9.819 2.834 5.516 1.508 11.268 2.152 16.926 1.49 6.084-.712 12.031-2.921 18.149-2.762 2.508.065 4.999.531 7.416 1.252 2.419.721 4.837 1.741 6.667 3.592 1.319 1.334 2.268 3.039 3.038 4.803 1.124 2.574 1.905 5.37 1.887 8.215-.01 1.48-.234 2.947-.368 4.42-.133 1.473-.173 2.981.18 4.411.355 1.437 1.092 2.733 1.936 3.909.844 1.176 1.802 2.251 2.676 3.402 2.447 3.222 4.195 6.978 6.101 10.6 1.906 3.622 4.043 7.206 7.053 9.815 4.097 3.551 9.412 4.97 13.979 7.776 1.337.822 2.633 1.786 3.573 3.1a8.333 8.333 0 0 1 1.448 3.624 8.56 8.56 0 0 1-.341 3.926",
    style: {},
    fill: "#ffc000",
    "data-original": "#ffc000"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 548.328,
    x2: 545.89,
    y1: 7109.088,
    y2: 7087.151,
    gradientTransform: "matrix(1 0 0 -1 -166.988 7472.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCD00"
    },
    stopColor: "#ffcd00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCD00",
      stopOpacity: 0
    },
    stopColor: "#ffcd00;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M334.845 363.166c5.646-1.529 10.455 2.753 14.55 5.985 2.646 2.257 6.469 1.689 9.715 1.796 5.379-.195 10.729.901 16.11.234 10.59-.895 20.973-3.498 31.613-3.947 5.083-.32 10.789-.616 15.181 2.353 1.78 1.233 4.39 6.448 6.147 4.49-.724-5.478-4.787-10.782-10.236-12.241-4.266-.671-8.6.502-12.908.123-12.794-.305-25.497-2.681-38.321-2-8.922.077-17.832-.336-26.741-.684-3.5-.715-4.734 2.394-6.634 3.586",
    style: {
      fill: "url(#f)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 175.242,
    x2: 257.504,
    y1: 7083.96,
    y2: 6945.941,
    gradientTransform: "matrix(1 0 0 -1 -96.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#CA8300"
    },
    stopColor: "#ca8300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#3B2100"
    },
    stopColor: "#3b2100"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M111.25 350.014c2.756-1.143 5.857-1.351 8.791-.809s5.707 1.809 8.175 3.486c4.936 3.354 8.597 8.235 12.104 13.063 8.052 11.089 15.802 22.41 22.828 34.176 5.699 9.544 10.933 19.401 17.518 28.357 4.298 5.846 9.146 11.271 13.466 17.101 4.32 5.83 8.149 12.161 10.064 19.16 2.489 9.094 1.525 19.119-2.804 27.495-3.045 5.893-7.715 10.948-13.396 14.372-5.681 3.424-12.359 5.195-18.987 4.947-10.538-.395-20.164-5.662-29.961-9.564-19.96-7.95-41.64-10.443-62.213-16.635-6.323-1.903-12.54-4.155-18.907-5.905-2.829-.778-5.703-1.462-8.374-2.674-2.672-1.212-5.17-3.015-6.656-5.544-1.149-1.955-1.635-4.257-1.603-6.524.031-2.267.562-4.506 1.334-6.638 1.544-4.264 4.039-8.124 5.722-12.335 2.749-6.876 3.243-14.458 2.872-21.853-.371-7.396-1.57-14.727-2.076-22.115-.226-3.299-.311-6.64.318-9.886.63-3.246 2.026-6.419 4.408-8.713 2.196-2.115 5.11-3.37 8.094-3.993 2.984-.623 6.059-.651 9.106-.582 3.048.069 6.102.231 9.141-.018 3.038-.25 6.09-.932 8.737-2.444 2.516-1.438 4.575-3.575 6.28-5.919 1.705-2.344 3.084-4.905 4.496-7.435 1.413-2.531 2.875-5.052 4.725-7.284 1.852-2.232 4.12-4.177 6.798-5.287",
    style: {
      fill: "url(#g)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.615 354.771c2.508-1.01 5.333-1.121 7.967-.524 2.634.597 5.084 1.879 7.219 3.528 4.27 3.298 7.238 7.952 10.09 12.528 6.843 11.087 13.532 22.292 19.848 33.724 4.786 8.606 9.35 17.395 15.232 25.299 3.902 5.242 8.354 10.051 12.337 15.23 3.982 5.18 7.534 10.827 9.295 17.12 2.269 8.111 1.349 17.08-2.577 24.53-2.822 5.353-7.156 9.904-12.385 12.948-5.229 3.044-11.339 4.566-17.384 4.288-9.649-.444-18.461-5.263-27.543-8.533-17.413-6.318-36.286-7.166-54.146-12.099-6.402-1.738-12.645-4.055-19.079-5.677-2.847-.718-5.745-1.305-8.449-2.446-2.704-1.141-5.251-2.91-6.717-5.454-1.091-1.891-1.526-4.116-1.459-6.298.067-2.182.619-4.327 1.396-6.366 1.554-4.08 3.999-7.774 5.565-11.849 2.376-6.16 2.671-12.933 2.23-19.521-.441-6.587-1.588-13.115-1.988-19.706-.179-2.945-.206-5.927.39-8.817.596-2.89 1.855-5.704 3.955-7.776 2.277-2.256 5.414-3.489 8.578-3.971 3.165-.483 6.387-.272 9.574.012 3.186.284 6.386.642 9.585.451 3.199-.191 6.439-.971 9.081-2.77 2.408-1.628 4.215-4.006 5.592-6.547 1.376-2.541 2.357-5.266 3.406-7.957s2.183-5.381 3.829-7.773c1.645-2.391 3.853-4.488 6.558-5.574",
    style: {},
    fill: "#ec9a00",
    "data-original": "#ec9a00",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.277 348.509c2.429-1.205 5.292-1.452 7.956-.909 2.664.544 5.133 1.846 7.231 3.547 4.197 3.403 6.86 8.251 9.34 13.008 5.696 10.925 11.002 22.088 17.818 32.376 4.944 7.463 10.651 14.416 15.652 21.842 6.783 10.072 12.299 21.15 14.575 33.017 1.531 7.982 1.48 16.603-2.365 23.794-2.531 4.733-6.636 8.615-11.484 11.044-4.849 2.429-10.416 3.414-15.837 2.936-8.539-.753-16.294-4.951-24.332-7.879-14.262-5.194-29.676-6.437-44.354-10.356-6.191-1.653-12.254-3.783-18.529-5.094-2.768-.578-5.59-1.001-8.233-1.996-2.642-.996-5.147-2.65-6.497-5.093-.95-1.719-1.269-3.731-1.128-5.683.142-1.951.725-3.85 1.49-5.657 1.53-3.612 3.793-6.922 4.982-10.656 1.746-5.488 1.028-11.437-.282-17.04s-3.2-11.105-3.782-16.826c-.259-2.548-.253-5.145.33-7.641.583-2.496 1.77-4.895 3.634-6.685 2.401-2.306 5.763-3.453 9.106-3.773 3.343-.32 6.708.117 10.031.594 3.323.478 6.667.999 10.022.846 3.355-.153 6.771-1.034 9.399-3.088 2.599-2.031 4.233-5.056 5.169-8.185.937-3.129 1.241-6.401 1.625-9.641.384-3.24.863-6.51 2.119-9.529 1.257-3.019 3.379-5.802 6.344-7.273",
    style: {},
    fill: "#ffbd00",
    "data-original": "#ffbd00",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 266.952,
    x2: 292.85,
    y1: 7051.645,
    y2: 7002.897,
    gradientTransform: "matrix(1 0 0 -1 -97.518 7472.405)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F8C400"
    },
    stopColor: "#f8c400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F8C400",
      stopOpacity: 0
    },
    stopColor: "#f8c400;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.704 375.781c4.492 8.124 7.232 17.445 11.688 25.637 4.099 7.536 8.763 15.294 12.926 22.244 1.854 3.094 6.176 7.85 10.546 15.231 3.96 6.689 7.96 16.024 10.197 19.158-1.285-3.669-3.928-13.524-7.081-20.549-2.946-6.564-6.377-10.31-8.491-13.841-4.163-6.95-8.647-13.196-12.926-19.82-5.905-9.136-10.404-19.363-16.859-28.06z",
    style: {
      fill: "url(#h)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 239.415,
    cy: 5869.984,
    r: 29.034,
    gradientTransform: "matrix(1.3082 .3505 .368 -1.3732 -2093.67 8365.933)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0200"
    },
    stopColor: "#0b0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    style: {
      stopColor: "#BB5A00",
      stopOpacity: 0.8
    },
    stopColor: "#bb5a00;stop-opacity:0.8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9200",
      stopOpacity: 0
    },
    stopColor: "#ff9200;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.98 375.214c-.97-1.899-2.735-3.319-4.703-4.141-1.968-.822-4.131-1.084-6.264-1.067-4.265.033-8.505 1.144-12.754.776-3.589-.311-6.995-1.66-10.496-2.512-3.615-.88-7.449-1.223-11.039-.246-3.836 1.044-7.221 3.608-9.34 6.972-1.869 2.966-2.756 6.468-3.035 9.962-.279 3.495.022 7.007.376 10.495.256 2.523.54 5.051 1.151 7.512.61 2.461 1.558 4.865 3.044 6.92 2.138 2.958 5.314 5.066 8.737 6.334 5.587 2.069 11.951 1.958 17.462-.305 9.753-4.235 18.009-11.83 23.041-21.197 1.802-3.354 3.201-6.927 4.105-10.626.359-1.47.641-2.969.655-4.482.015-1.512-.252-3.047-.94-4.395",
    style: {
      opacity: 0.35,
      fill: "url(#i)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 4.609,
    cy: 6704.802,
    r: 29.034,
    gradientTransform: "matrix(1.3082 .2534 .368 -.9927 -2093.67 7034.724)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0B0200"
    },
    stopColor: "#0b0200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    style: {
      stopColor: "#BB5A00",
      stopOpacity: 0.8
    },
    stopColor: "#bb5a00;stop-opacity:0.8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF9200",
      stopOpacity: 0
    },
    stopColor: "#ff9200;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M410.98 369.775c-.97-1.373-2.735-2.4-4.703-2.993-1.968-.594-4.131-.784-6.264-.772-4.265.024-8.505.827-12.754.561-3.589-.224-6.995-1.2-10.496-1.816-3.615-.636-7.449-.884-11.039-.178-3.836.755-7.221 2.609-9.34 5.04-1.869 2.144-2.756 4.676-3.035 7.202-.279 2.526.022 5.066.376 7.587.256 1.824.54 3.652 1.151 5.431.61 1.779 1.558 3.517 3.044 5.003 2.138 2.138 5.314 3.663 8.737 4.579 5.587 1.496 11.951 1.415 17.462-.221 9.753-3.061 18.009-8.552 23.041-15.324 1.802-2.425 3.201-5.008 4.105-7.682.359-1.063.641-2.146.655-3.24.014-1.093-.252-2.203-.94-3.177",
    style: {
      opacity: 0.35,
      fill: "url(#j)",
      enableBackground: "new"
    },
    fill: ""
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M419.39 365.22c-.76 3.37-2.43 6.47-4.4 9.31-5.95 8.63-14.76 15.25-24.7 18.58-6.02 1.97-12.64 2.07-18.71.27-3.53-1.04-6.95-2.78-9.37-5.55-2.99-3.44-4.13-8.11-4.49-12.65-.49-6.1.31-12.36 2.85-17.93 1.02-2.24 2.32-4.36 3.91-6.23.64-.78 1.34-1.52 2.09-2.2 2.57-2.34 5.7-4.09 9.09-4.86 3.87-.87 7.92-.45 11.83.22 3.77.64 7.5 1.5 11.25 2.2 3.98.75 8.04 1.34 11.78 2.92 1.25.53 2.46 1.18 3.58 1.97.55.37 1.07.78 1.56 1.22 1.5 1.36 2.73 3.05 3.43 4.95.9 2.47.88 5.21.3 7.78z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 407.913,
    cy: 366.567,
    r: 9.825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D7D7D"
    },
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7D7D",
      stopOpacity: 0.3294
    },
    stopColor: "#7d7d7d;stop-opacity:0.3294"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.66 361.59c-.92 1.66-2.32 2.96-3.87 4.04-3.67 2.57-8.14 3.78-12.55 4.63.96-.85 1.94-1.73 2.85-2.63 1.13-1.12 2.18-2.34 2.96-3.72.78-1.39 1.23-3.02.92-4.58-.21-1.06-.75-2.02-1.46-2.85-.7-.83-1.53-1.54-2.42-2.16-3.82-2.67-8.32-4.18-12.87-5.17-2.94-.64-5.96-1.03-8.94-1.4-3.11-.39-6.29-.73-9.37-.16-1.11.2-2.19.53-3.23.96-.2.08-.41.16-.61.27-.08.03-.16.06-.23.11-.24.1-.48.22-.71.35-.04.02-.08.04-.11.06-.29.15-.57.31-.85.49-.29.18-.58.37-.86.57-.29.19-.56.39-.83.61.65-.78 1.34-1.51 2.09-2.19 2.57-2.34 5.7-4.09 9.09-4.86 3.87-.87 7.92-.45 11.83.22 3.77.64 7.5 1.5 11.25 2.2 3.98.75 8.04 1.34 11.78 2.92 1.25.53 2.46 1.18 3.58 1.97.14.11.28.23.42.35.21.17.41.36.61.56.2.18.38.38.56.58.85.96 1.53 2.1 1.84 3.34.45 1.84.06 3.84-.87 5.49z",
    style: {
      fill: "url(#k)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 377.13,
    x2: 381.708,
    y1: 356.303,
    y2: 356.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#7D7D7D"
    },
    stopColor: "#7d7d7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7D7D",
      stopOpacity: 0.3294
    },
    stopColor: "#7d7d7d;stop-opacity:0.3294"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M416.66 361.59c-.92 1.66-2.32 2.96-3.87 4.04-3.67 2.57-8.14 3.78-12.55 4.63.96-.85 1.94-1.73 2.85-2.63 1.13-1.12 2.18-2.34 2.96-3.72.78-1.39 1.23-3.02.92-4.58-.21-1.06-.75-2.02-1.46-2.85-.7-.83-1.53-1.54-2.42-2.16-3.82-2.67-8.32-4.18-12.87-5.17-2.94-.64-5.96-1.03-8.94-1.4-3.11-.39-6.29-.73-9.37-.16-1.11.2-2.19.53-3.23.96-.21.08-.41.17-.61.27-.08.03-.16.06-.23.11-.24.1-.48.22-.71.35-.04.02-.08.04-.11.06-.29.15-.57.32-.85.49-.29.18-.58.37-.86.57-.28.2-.56.4-.83.62v-.01c.65-.78 1.34-1.51 2.09-2.19 2.57-2.34 5.7-4.09 9.09-4.86 3.87-.87 7.92-.45 11.83.22 3.77.64 7.5 1.5 11.25 2.2 3.98.75 8.04 1.34 11.78 2.92 1.25.53 2.46 1.18 3.58 1.97.14.11.28.23.42.35.21.17.41.36.61.56.2.18.38.38.56.58.85.96 1.53 2.1 1.84 3.34.45 1.84.06 3.84-.87 5.49z",
    style: {
      fill: "url(#l)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 179.13,
    cy: 6747.294,
    r: 24.553,
    gradientTransform: "matrix(.8152 -.0343 -.0296 -1.248 266.768 8530.951)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDFDFB"
    },
    stopColor: "#fdfdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    style: {
      stopColor: "#FDFDFB"
    },
    stopColor: "#fdfdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4D4D4"
    },
    stopColor: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M208.557 79.217c-3.07.167-4.864.621-7.11 2.72-2.246 2.099-2.661 3.754-3.634 6.67-.873 2.616-3.237 4.736-3.366 7.489-.158 3.382.085 6.821.329 10.202.401 5.553.811 11.212 2.89 16.376 1.04 2.582 2.5 5.016 4.447 7.004 1.948 1.989 4.398 3.519 7.098 4.196 2.532.634 5.236.503 7.726-.279s4.764-2.204 6.629-4.029c2.721-2.663 4.556-6.146 5.607-9.806 1.052-3.659 1.352-7.5 1.297-11.307-.068-4.764-.691-9.546-2.182-14.071-.821-2.491-1.911-4.905-3.279-7.141-1.117-1.826-3.681-1.864-5.174-3.4-1.609-1.655-3.573-1.504-5.643-2.525s-3.33-2.225-5.635-2.099",
    style: {
      fill: "url(#m)"
    },
    fill: ""
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M201.496 101.988c-.641 3.871-.665 7.932.666 11.622.879 2.437 2.327 4.648 4.088 6.548 1.153 1.244 2.462 2.375 3.991 3.108 1.53.733 3.302 1.045 4.947.632 1.519-.381 2.846-1.359 3.826-2.58s1.633-2.677 2.099-4.171c1.374-4.413 1.153-9.241-.211-13.657-.994-3.218-2.641-6.322-5.216-8.491-1.229-1.035-2.668-1.846-4.231-2.218-1.563-.371-3.255-.284-4.718.38-1.624.738-2.881 2.142-3.704 3.725-.822 1.582-1.245 3.342-1.537 5.102",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: 275.839,
    x2: 285.894,
    y1: 7381.039,
    y2: 7363.063,
    gradientTransform: "matrix(1 0 0 -1 -66.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#767675",
      stopOpacity: 0
    },
    stopColor: "#767675;stop-opacity:0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.263,
    style: {
      stopColor: "#767675"
    },
    stopColor: "#767675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#767675"
    },
    stopColor: "#767675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#767675",
      stopOpacity: 0
    },
    stopColor: "#767675;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M209.68 99.188c.417 1.092 1.817 1.489 2.585 2.37.746.856 1.529 1.742 1.939 2.801.784 2.027-.774 5.031.862 6.463.513.449 1.542.459 2.047 0 1.974-1.796 1.536-5.419.754-7.971-.709-2.316-2.46-4.509-4.618-5.61-.998-.509-2.5-.932-3.354-.207-.549.467-.472 1.48-.215 2.154z",
    style: {
      fill: "url(#n)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 209.216,
    cy: 83.29,
    r: 17.514,
    fx: 208.251,
    fy: 81.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4D4D4"
    },
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7D7D"
    },
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.01 87.25c-2.35-.56-4.71-1-7.11-1.22-5.36-.51-10.99.13-15.62 2.89-3.06 1.82-5.5 4.43-7.82 7.16.12-2.75.51-5.46 1.38-8.07.98-2.91 2.56-5.66 4.8-7.76 2.25-2.1 5.19-3.52 8.26-3.68 2.3-.13 4.61.45 6.68 1.47 2.07 1.02 3.91 2.47 5.52 4.13 1.5 1.54 2.8 3.25 3.91 5.08z",
    style: {
      fill: "url(#o)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: 366.191,
    x2: 389.286,
    y1: 7411.264,
    y2: 7389.023,
    gradientTransform: "matrix(1 0 0 -1 -156.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#646464",
      stopOpacity: 0
    },
    stopColor: "#646464;stop-opacity:0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    style: {
      stopColor: "#646464",
      stopOpacity: 0.5825
    },
    stopColor: "#646464;stop-opacity:0.5825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#646464"
    },
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    style: {
      stopColor: "#646464",
      stopOpacity: 0.2573
    },
    stopColor: "#646464;stop-opacity:0.2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#646464",
      stopOpacity: 0
    },
    stopColor: "#646464;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.529 73.147c4.315 4.042 7.523 9.031 9.695 14.321-.949-5.834-2.453-10.52-6.248-14.321-2.329-2.182-4.975-4.098-7.971-5.444-2.622-1.178-5.539-1.909-7.206-1.94-1.667-.03-2.072.007-2.415.023-.343.016-.616.028.469.151s3.505.778 6.103 1.945c2.599 1.167 5.245 3.083 7.573 5.265z",
    style: {
      fill: "url(#p)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 547.202,
    cy: 6736.285,
    r: 23.988,
    gradientTransform: "matrix(1.0858 -.0343 -.0394 -1.248 -52.29 8530.951)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FDFDFB"
    },
    stopColor: "#fdfdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.757,
    style: {
      stopColor: "#FDFDFB"
    },
    stopColor: "#fdfdfb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#D4D4D4"
    },
    stopColor: "#d4d4d4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M265.475 80.993c-4.491 3.085-12.664 7.983-12.664 7.983-.162.37-.243.604-.366.948-2.475 6.897-1.527 14.617.862 21.544 2.447 7.096 6.539 13.859 12.718 18.118 3.09 2.13 6.667 3.59 10.393 4.031 3.727.441 7.599-.164 10.928-1.897 4.056-2.113 7.149-5.813 9.069-9.963 1.921-4.15 2.738-8.738 2.995-13.304.23-4.08.018-8.208-.789-12.208-.343-1.703-2.622-2.97-3.193-4.614-2.077-5.979-6.179-6.97-11.492-10.41-2.657-1.72-4.811-2.738-7.946-3.171-3.135-.434-3.602-.353-6.552.793-1.68.651-2.476 1.129-3.963 2.15",
    style: {
      fill: "url(#q)"
    },
    fill: ""
  }), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M274.267 91.035c-1.802.129-3.558.744-5.087 1.707s-2.832 2.267-3.855 3.756c-2.047 2.977-2.945 6.63-3.09 10.24-.109 2.71.191 5.455 1.09 8.014.899 2.559 2.414 4.927 4.503 6.657a13.04 13.04 0 0 0 7.626 2.966 12.797 12.797 0 0 0 7.861-2.252c1.815-1.263 3.278-3.002 4.32-4.952 1.042-1.95 1.67-4.108 1.957-6.3.507-3.872-.066-7.916-1.856-11.387s-4.827-6.33-8.491-7.68c-1.587-.585-3.29-.89-4.978-.769",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })), /*#__PURE__*/React.createElement("path", {
    d: "M278.567 102.85c-1.492.589-3.855.218-4.509 1.683-.388.868.16 2.297 1.04 2.655 1.779.725 4.536-.588 5.255-2.37.312-.774-.161-2.001-.93-2.324-.285-.119-.569.243-.856.356z",
    style: {},
    fill: "#0c0c0b",
    "data-original": "#0c0c0b",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 352.74,
    x2: 364.318,
    y1: 7379.678,
    y2: 7365.968,
    gradientTransform: "matrix(1 0 0 -1 -76.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#949494",
      stopOpacity: 0.3922
    },
    stopColor: "#949494;stop-opacity:0.3922"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#949494"
    },
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#949494",
      stopOpacity: 0.3922
    },
    stopColor: "#949494;stop-opacity:0.3922"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M285.407 106.728c2.001-2.001-1.424-7.307-4.093-9.479-1.934-1.573-7.567-3.22-7.325-1.508s2.775 3.906 4.472 5.58c2.089 2.06 5.996 6.358 6.946 5.407z",
    style: {
      fill: "url(#r)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 279.608,
    cy: 86.092,
    r: 21.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4D4D4"
    },
    stopColor: "#d4d4d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7D7D"
    },
    stopColor: "#7d7d7d"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.64 96.31c-2.56-2.06-5.08-4.19-7.85-5.96-9.27-5.88-21.18-7.16-31.67-3.92-2.18.67-4.29 1.52-6.31 2.55 2.06-5.05 5.89-9.31 10.41-12.41 1.48-1.02 3.06-1.94 4.74-2.59 2.95-1.14 6.2-1.47 9.33-1.04 3.14.44 6.15 1.62 8.81 3.34 5.31 3.44 9.08 8.96 11.16 14.94.58 1.66 1.03 3.36 1.38 5.09z",
    style: {
      fill: "url(#s)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 436.485,
    x2: 461.011,
    y1: 7412.301,
    y2: 7389.146,
    gradientTransform: "matrix(1 0 0 -1 -156.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#646464",
      stopOpacity: 0
    },
    stopColor: "#646464;stop-opacity:0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.306,
    style: {
      stopColor: "#646464",
      stopOpacity: 0.5825
    },
    stopColor: "#646464;stop-opacity:0.5825"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "#646464"
    },
    stopColor: "#646464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.728,
    style: {
      stopColor: "#646464",
      stopOpacity: 0.2573
    },
    stopColor: "#646464;stop-opacity:0.2573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#646464",
      stopOpacity: 0
    },
    stopColor: "#646464;stop-opacity:0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.86 62.37c-.822 1.034-1.565 2.158-2.154 3.393 3.699.797 7.237 2.319 10.395 4.417 6.11 4.058 10.75 9.99 14.004 16.589a17.177 17.177 0 0 0 2.047-2.747c-3.27-6.873-8.004-13.09-14.327-17.289-3.039-2.018-6.421-3.54-9.965-4.363z",
    style: {
      fill: "url(#t)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 2719.878,
    cy: 8298.458,
    r: 26.512,
    gradientTransform: "matrix(.6978 -.5072 -.4603 -.6334 2157.33 6755.998)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    style: {
      stopColor: "#000000"
    },
    stopColor: "#000000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5C5C5C"
    },
    stopColor: "#5c5c5c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.319 117.069c3.046-3.424 5.13-7.602 8.056-11.128 1.463-1.763 3.151-3.37 5.139-4.51 1.988-1.14 4.295-1.794 6.578-1.597 2.541.22 4.92 1.486 6.78 3.231 1.861 1.745 3.24 3.947 4.341 6.248 1.054 2.203 1.892 4.551 3.411 6.463 1.621 2.041 3.894 3.434 5.948 5.038 1.027.802 2.012 1.67 2.824 2.69.812 1.019 1.447 2.199 1.708 3.476.265 1.296.133 2.663-.319 3.906-.452 1.243-1.218 2.364-2.171 3.282-1.906 1.836-4.505 2.826-7.125 3.197-5.24.741-10.539-.82-15.829-.675-5.355.147-10.585 2.04-15.938 1.844-2.677-.098-5.391-.752-7.591-2.28-1.1-.764-2.058-1.742-2.75-2.888-.693-1.146-1.115-2.463-1.16-3.801-.043-1.277.255-2.552.765-3.724.51-1.171 1.228-2.244 2.037-3.232 1.618-1.978 3.597-3.63 5.296-5.54",
    style: {
      fill: "url(#u)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 1765.522,
    cy: 8881.038,
    r: 53.621,
    gradientTransform: "matrix(.9362 -.3864 -.2713 -.6574 1016.38 6661.705)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#E59400"
    },
    stopColor: "#e59400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.751,
    style: {
      stopColor: "#EB9C00"
    },
    stopColor: "#eb9c00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.866,
    style: {
      stopColor: "#C87F00"
    },
    stopColor: "#c87f00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A46100"
    },
    stopColor: "#a46100"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.279 150.108c.106.509.297 1 .564 1.447.458.768 1.127 1.39 1.85 1.916.723.526 1.504.964 2.261 1.44 4.022 2.528 7.3 6.082 10.211 9.836 3.906 5.036 7.363 10.625 12.58 14.286 3.684 2.585 8.093 4.059 12.571 4.509 5.259.528 10.582-.32 15.652-1.813 4.699-1.383 9.243-3.326 13.413-5.897 7.926-4.888 14.545-12.052 23.285-15.265 1.908-.701 3.894-1.203 5.733-2.069 1.839-.865 3.57-2.161 4.449-3.995.845-1.762.812-3.796 1.087-5.731.294-2.07.954-4.071 1.317-6.13.362-2.059.405-4.261-.485-6.153-.737-1.566-2.077-2.806-3.619-3.593s-3.277-1.145-5.006-1.23c-3.458-.17-6.873.716-10.321 1.03-4.567.417-9.165-.169-13.749-.033-5.702.17-11.321 1.456-17.018 1.732-6.5.315-12.986-.687-19.489-.95-2.816-.114-5.653-.088-8.431.388-2.778.477-5.507 1.42-7.826 3.021-2.26 1.561-4.06 3.689-6.136 5.488-1.038.9-2.154 1.722-3.389 2.322-1.235.6-2.598.972-3.971.943-.706-.016-1.432-.133-2.105.081-.42.134-.794.391-1.109.7-.316.308-.577.667-.824 1.033a18.231 18.231 0 0 0-1.495 2.687",
    style: {
      fill: "url(#v)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.796 157.116a11.548 11.548 0 0 0 1.109 8.222 11.547 11.547 0 0 0 6.381 5.303c3.409 1.136 7.25.58 10.435-1.083 1.847-.964 3.535-2.32 4.601-4.109a7.773 7.773 0 0 0 1.042-2.923 6.424 6.424 0 0 0-.319-3.077c-.396-1.071-1.104-2.014-1.975-2.751-.872-.737-1.904-1.272-2.988-1.63-2.167-.717-4.5-.731-6.78-.621-3.456.166-6.899.6-10.288 1.298",
    style: {},
    fill: "#e6b300",
    "data-original": "#e6b300",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.61 135.714c-2.308 1.364-4.53 2.867-6.717 4.418-1.132.802-2.299 1.67-2.896 2.922-.423.888-.52 1.894-.534 2.877-.013.983.05 1.972-.08 2.946-.088.666-.266 1.321-.296 1.991a3.23 3.23 0 0 0 .097.999c.088.324.245.633.475.877.297.316.703.51 1.118.637.415.126.846.192 1.268.291 2.025.476 3.786 1.718 5.333 3.109 1.546 1.391 2.935 2.956 4.548 4.268 4.373 3.558 10.152 5.03 15.789 5.123 5.637.093 11.21-1.087 16.71-2.326 4.32-.973 8.643-1.99 12.798-3.522 6.382-2.353 12.307-5.915 17.439-10.379 2.327-2.024 4.511-4.246 7.122-5.886 2.311-1.451 4.899-2.409 7.25-3.796a4.6 4.6 0 0 0 .607-.408c.188-.156.355-.341.463-.56.188-.377.189-.829.067-1.233-.121-.404-.356-.765-.62-1.093a7.56 7.56 0 0 0-.981-.995c-2.455-2.101-5.785-2.865-9.007-3.121-3.221-.255-6.482-.075-9.669-.607-2.997-.501-5.848-1.618-8.741-2.546a64.484 64.484 0 0 0-9.288-2.259c-7.402-1.208-15.024-.976-22.367.553a65.326 65.326 0 0 0-19.888 7.72",
    style: {},
    fill: "#694200",
    "data-original": "#694200",
    className: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 363.167,
    x2: 460.512,
    y1: 7336.189,
    y2: 7336.951,
    gradientTransform: "matrix(1 0 0 -1 -166.988 7474.173)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#BE7900"
    },
    stopColor: "#be7900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    style: {
      stopColor: "#EA9E00"
    },
    stopColor: "#ea9e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.255,
    style: {
      stopColor: "#FFB800"
    },
    stopColor: "#ffb800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.392,
    style: {
      stopColor: "#F7C800"
    },
    stopColor: "#f7c800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.527,
    style: {
      stopColor: "#FFD815"
    },
    stopColor: "#ffd815"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.769,
    style: {
      stopColor: "#FFD800"
    },
    stopColor: "#ffd800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FFCD04"
    },
    stopColor: "#ffcd04"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M207.874 127.914a40.947 40.947 0 0 0-8.852 8.075c-1.449 1.777-2.764 3.707-3.494 5.88-.574 1.709-.77 3.519-1.131 5.285-.135.662-.295 1.326-.293 2.001.001.338.044.677.149.998s.273.624.507.868c.387.403.931.622 1.479.735.548.113 1.11.129 1.665.193 2.507.285 4.816 1.503 6.895 2.934 2.078 1.431 3.994 3.094 6.126 4.443 4.712 2.98 10.332 4.306 15.903 4.521 5.571.215 11.129-.632 16.597-1.723 4.345-.868 8.676-1.897 12.798-3.522 6.312-2.489 12.002-6.32 17.439-10.379 2.47-1.844 4.905-3.746 7.122-5.886.753-.727 1.481-1.481 2.288-2.147.807-.665 1.703-1.244 2.699-1.564 1.518-.488 3.164-.348 4.737-.085 1.185.198 2.372.464 3.572.416a5.3 5.3 0 0 0 1.758-.351 3.62 3.62 0 0 0 1.453-1.032c.502-.609.758-1.404.761-2.193.003-.789-.239-1.57-.639-2.25-.801-1.36-2.186-2.28-3.628-2.921-1.975-.878-4.113-1.312-6.214-1.82a89.095 89.095 0 0 1-18.676-6.815c-2.957-1.468-5.832-3.095-8.741-4.654-2.991-1.603-6.04-3.144-9.288-4.128-7.262-2.201-15.199-1.479-22.367 1.01a47.797 47.797 0 0 0-20.625 14.111",
    style: {
      fill: "url(#w)"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.888 129.509c-.39-.493-.95-.841-1.553-1.019-.604-.178-1.249-.19-1.869-.084-1.24.212-2.352.88-3.388 1.593-2.945 2.028-5.548 4.53-7.82 7.29-3.008 3.654-5.489 7.879-6.321 12.538-.14.785-.233 1.588-.135 2.379s.401 1.577.963 2.143c.493.497 1.165.8 1.858.9.693.1 1.406.003 2.07-.221 1.327-.448 2.428-1.378 3.472-2.312 5.75-5.146 10.949-11.32 13.029-18.75.209-.746.386-1.509.381-2.283-.005-.773-.206-1.567-.687-2.174",
    style: {},
    fill: "#ffda37",
    "data-original": "#ffda37",
    className: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 206.283,
    cy: 9715.66,
    r: 5.567,
    gradientTransform: "matrix(1 0 0 -.5833 43.012 5786.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D2400"
    },
    stopColor: "#3d2400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#7E5100"
    },
    stopColor: "#7e5100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B78C00"
    },
    stopColor: "#b78c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M245.122 118.841c.399 1.28 2.461 1.067 3.652 1.681 1.045.538 1.886 1.719 3.062 1.753 1.122.032 2.868-.389 3.014-1.501.193-1.47-1.954-2.404-3.336-2.943-1.778-.693-4.055-1.045-5.723-.118-.382.212-.799.71-.669 1.128z",
    style: {
      opacity: 0.8,
      fill: "url(#x)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 181.211,
    cy: 7123.485,
    r: 2.646,
    gradientTransform: "matrix(1 0 0 -1.0751 43.012 7778.352)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#3D2400"
    },
    stopColor: "#3d2400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.555,
    style: {
      stopColor: "#7E5100"
    },
    stopColor: "#7e5100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#B78C00"
    },
    stopColor: "#b78c00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M225.433 118.117c-1.531-.497-4.063 2.202-3.237 3.583.227.379.922.86 1.39.603.705-.388 1.282-1.774 2.047-2.318.509-.363.395-1.674-.2-1.868z",
    style: {
      opacity: 0.8,
      fill: "url(#y)",
      enableBackground: "new"
    },
    fill: ""
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 148.112,
    x2: 148.865,
    y1: 6212.699,
    y2: 6207.959,
    gradientTransform: "matrix(1.0956 0 .1702 -1.5181 -925.948 9566.652)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE00"
    },
    stopColor: "#ffce00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#EA9B00"
    },
    stopColor: "#ea9b00"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M298.529 138.297c-.377 3.364-2.888 6.092-5.608 6.092-2.72 0-4.619-2.727-4.242-6.092.377-3.364 2.888-6.092 5.608-6.092 2.719 0 4.619 2.728 4.242 6.092z",
    style: {
      fill: "url(#z)"
    },
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinux);
export default __webpack_public_path__ + "static/media/linux.50f9a2434890213eadff4e0112657703.svg";
export { ForwardRef as ReactComponent };